import { Reducer } from 'react';

import { MemberInformationRoleFormSchema } from 'features/Team/components/MemberInformationRoleForm/schema';

import { QuickInvitation } from '../../hooks/useQuickInvitations';
import { MemberInformationFormSchema } from '../MemberInviteStepper/steps/MemberInformation/MemberInformationForm/schema';

const mapBeneficiaryInvitationToMemberInformation = (
  beneficiaryInvitation: QuickInvitation | false,
): MemberInformationFormSchema => {
  return beneficiaryInvitation
    ? {
        inviteeEmail: beneficiaryInvitation.email ?? '',
        inviteeFirstName: beneficiaryInvitation.firstName ?? '',
        inviteeLastName: beneficiaryInvitation.lastName ?? '',
      }
    : {
        inviteeEmail: '',
        inviteeFirstName: '',
        inviteeLastName: '',
      };
};

export type State = {
  isFreeRolesOnly: boolean;
  shouldShowLegalBeneficiarySelector: boolean;
  selectedLegalBeneficiary: QuickInvitation | false;
  memberInformation: MemberInformationFormSchema;
  memberRole: Partial<MemberInformationRoleFormSchema>;
};

export type Action =
  | {
      type: 'SET_SHOULD_SHOW_LB_FORM';
      payload: boolean;
    }
  | {
      type: 'SELECT_LEGAL_BENEFICIARY';
      payload: QuickInvitation | false;
    }
  | {
      type: 'SUBMIT_INVITE_ROLE';
      payload: MemberInformationRoleFormSchema;
    }
  | {
      type: 'SUBMIT_INVITE_INFORMATION';
      payload: MemberInformationFormSchema;
    }
  | {
      type: 'SET_ACCOUNTANT_ONLY';
      payload: boolean;
    };

export const memberInviteReducer: Reducer<State, Action> = (state, action) => {
  switch (action.type) {
    case 'SET_SHOULD_SHOW_LB_FORM':
      return {
        ...state,
        shouldShowLegalBeneficiarySelector: action.payload,
      };
    case 'SET_ACCOUNTANT_ONLY':
      return {
        ...state,
        isFreeRolesOnly: action.payload,
      };
    case 'SELECT_LEGAL_BENEFICIARY':
      return {
        ...state,
        memberInformation: mapBeneficiaryInvitationToMemberInformation(
          action.payload,
        ),
        selectedLegalBeneficiary: action.payload,
      };
    case 'SUBMIT_INVITE_INFORMATION':
      return {
        ...state,
        memberInformation: action.payload,
      };
    case 'SUBMIT_INVITE_ROLE':
      return {
        ...state,
        memberRole: action.payload,
      };
    default:
      return state;
  }
};
